import { useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ModuleCatalogResponse, ApiError } from '../types/showcase';

/**
 * Query: GET /api/eraf/showcase/modules
 * Fetches the full module catalog tree.
 * p95 target < 100ms (server-side cache).
 */
export function useModuleCatalog(artifact?: string) {
  return useQuery<ModuleCatalogResponse, ApiError>({
    queryKey: ['common-showcase', 'modules', artifact ?? 'all'],
    queryFn: () => showcaseApi.getModules(artifact),
    retry: false,
    staleTime: 60_000,
  });
}
